import { lazy } from 'react';
import { Route } from 'react-router-dom';
import DashboardLayout from '../dashboard/_components/dashboard-layout';

const ChatStudioPage = lazy(() => import('../dashboard/studio/chat/page'));
const ImageGenerationStudioPage = lazy(
  () => import('../dashboard/studio/image-generation/page'),
);
const VideoGenerationStudioPage = lazy(
  () => import('../dashboard/studio/video-generation/page'),
);
const AudioTranscriptionStudioPage = lazy(
  () => import('../dashboard/studio/audio-transcription/page'),
);
const TextToSpeechStudioPage = lazy(
  () => import('../dashboard/studio/text-to-speech/page'),
);
const EmbeddingsStudioPage = lazy(
  () => import('../dashboard/studio/embeddings/page'),
);
const ModerationStudioPage = lazy(
  () => import('../dashboard/studio/moderation/page'),
);

export const StudioRoutes = (
  <>
    <Route
      path="/dashboard/studio/chat"
      element={
        <DashboardLayout>
          <ChatStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/image-generation"
      element={
        <DashboardLayout>
          <ImageGenerationStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/video-generation"
      element={
        <DashboardLayout>
          <VideoGenerationStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/audio-transcription"
      element={
        <DashboardLayout>
          <AudioTranscriptionStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/text-to-speech"
      element={
        <DashboardLayout>
          <TextToSpeechStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/embeddings"
      element={
        <DashboardLayout>
          <EmbeddingsStudioPage />
        </DashboardLayout>
      }
    />
    <Route
      path="/dashboard/studio/moderation"
      element={
        <DashboardLayout>
          <ModerationStudioPage />
        </DashboardLayout>
      }
    />
  </>
);
